var _defs, _use, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreate = function SvgCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 18 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "create_svg__a",
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "create_svg__b",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#create_svg__a"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#create_svg__a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#create_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 8V4h2v4h4v2h-4v4H8v-4H4V8h4z"
  }))));
};
export { SvgCreate as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPGRlZnM+CiAgICA8cmVjdCBpZD0icmVjdC0xIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHg9IjAiIHk9IjAiLz4KICAgIDxtYXNrIGlkPSJtYXNrLTIiIG1hc2tDb250ZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiB4PSIwIiB5PSIwIiBmaWxsPSJibGFjayIvPgogICAgICA8dXNlIGZpbGw9IndoaXRlIiB4bGluazpocmVmPSIjcmVjdC0xIi8+CiAgICA8L21hc2s+CiAgPC9kZWZzPgogIDxnPgogICAgPHVzZSBmaWxsPSJub25lIiB4bGluazpocmVmPSIjcmVjdC0xIi8+CiAgICA8ZyBtYXNrPSJ1cmwoI21hc2stMikiPgogICAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDhWNGgydjRoNHYyaC00djRIOHYtNEg0VjhoNHoiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";